// extracted by mini-css-extract-plugin
export default {"modal":"SupportTicketsModal_modal__XpIb-","content":"SupportTicketsModal_content__aieal","toggle":"SupportTicketsModal_toggle__NI7qt"};